import { UnitType } from '@exodus/currency'

const name = 'bcash'
const displayName = 'Bitcoin Cash'
const ticker = 'BCH'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#0AC18E'
const gradientColors = ['#0AC18E', '#57F5C9']
const gradientCoords = { x1: '115.077%', y1: '77.227%', x2: '27.227%', y2: '34.923%' }
const chainBadgeColors = gradientColors

const units = {
  satoshis: 0,
  BCH: 8,
}
const currency = UnitType.create(units)

const assetType = 'BITCOIN_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://blockchair.com/bitcoin-cash/address/${address}`,
  txUrl: (txId) => `https://blockchair.com/bitcoin-cash/transaction/${txId}`,
}
const info = {
  description:
    'Bitcoin Cash is a fork, or split, from the original Bitcoin that attempts to increase network transaction capacity in order to be useful for small, everyday transactions.',
  reddit: 'https://www.reddit.com/r/Bitcoincash/',
  website: 'https://www.bitcoincash.org/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
